@if(isAllNotificationsVisible) {
  <div class="notifs-list flex flex-column w-full">
    @if(notificationsList) {
      @for(notification of notificationsList; track notification._id) {
        <app-notification-card [notification]="notification"/>
      } @empty {
        <div class="text-sm w-full text-center my-4">No notifications match your selected options</div>
      }
    } @else {
      <app-notifications-skeleton />
    }
  </div>
} @else {
  <div class="notifs-list flex flex-column w-full">
    @if(newNotifications) {
      @for(notification of newNotifications; track notification._id) {
        <app-notification-card [notification]="notification"/>
      } @empty {
        <div class="text-sm w-full text-center my-4">You're all caught up! No new notifications</div>
      }
    } @else {
      <app-notifications-skeleton />
    }
  </div>
}

@if(isAllNotificationsVisible) {
  <div class="paginator-container flex align-items-center justify-content-center pt-1 absolute">
    <p-dropdown
      styleClass="text-xs"
      [options]="options"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="rows"
      (ngModelChange)="onLimitChange()"
      appendTo="body"
    />
    <p-paginator
      styleClass="text-xs py-0"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      (onPageChange)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} of {totalRecords}"
      [showPageLinks]="false"
      [showFirstLastIcon]="false">
    </p-paginator>
  </div>
}
